import React, { useState } from 'react';
import ActionButton from '../elements/ActionButton/ActionButton';

import gatoradeImg from 'url:../../assets-optimized/redesign/partnerStories/gatorade-tabs-section.jpg';
import gatoradeImgavif from 'url:../../assets-optimized/redesign/partnerStories/gatorade-tabs-section.avif';
import gatoradeImgwebp from 'url:../../assets-optimized/redesign/partnerStories/gatorade-tabs-section.webp';
import gatoradeLogo from 'url:../../assets-optimized/redesign/partnerStories/gatorade_logo.png';
import gatoradeLogoavif from 'url:../../assets-optimized/redesign/partnerStories/gatorade_logo.avif';
import gatoradeLogowebp from 'url:../../assets-optimized/redesign/partnerStories/gatorade_logo.webp';
import OptimizedImage from './OptimizedImage';
import unitedImg from 'url:../../assets-optimized/redesign/partnerStories/united.jpg';
import unitedImgavif from 'url:../../assets-optimized/redesign/partnerStories/united.avif';
import unitedImgwebp from 'url:../../assets-optimized/redesign/partnerStories/united.webp';
import unitedLogo from 'url:../../assets-optimized/redesign/partnerStories/united_logo.png';
import unitedLogoavif from 'url:../../assets-optimized/redesign/partnerStories/united_logo.avif';
import unitedLogowebp from 'url:../../assets-optimized/redesign/partnerStories/united_logo.webp';
import visaImg from 'url:../../assets-optimized/redesign/partnerStories/visa.jpg';
import visaImgavif from 'url:../../assets-optimized/redesign/partnerStories/visa.avif';
import visaImgwebp from 'url:../../assets-optimized/redesign/partnerStories/visa.webp';
import visaLogo from 'url:../../assets-optimized/redesign/partnerStories/visa_logo.png';
import visaLogoavif from 'url:../../assets-optimized/redesign/partnerStories/visa_logo.avif';
import visaLogowebp from 'url:../../assets-optimized/redesign/partnerStories/visa_logo.webp';

import partnerStoriesData from './partnerStories.json';

import './PartnerStoriesTabs.css';

const images = {
  gatorade: { avif: gatoradeImgavif, webp: gatoradeImgwebp, fallback: gatoradeImg },
  visa: { avif: visaImgavif, webp: visaImgwebp, fallback: visaImg },
  united: { avif: unitedImgavif, webp: unitedImgwebp, fallback: unitedImg },
};

// Pre-composed banners (logo + label baked in) that replace the image + overlay
// for a given brand. When a brand has a banner, render it on its own.
const banners = {};

const logos = {
  gatorade: { avif: gatoradeLogoavif, webp: gatoradeLogowebp, fallback: gatoradeLogo },
  visa: { avif: visaLogoavif, webp: visaLogowebp, fallback: visaLogo },
  united: { avif: unitedLogoavif, webp: unitedLogowebp, fallback: unitedLogo },
};

// Hardcoded for now based on mockup since JSON doesn't have it
const brandLabels = {
  gatorade: 'ICONIC SPORTS &\nHYDRATION BRAND',
  visa: 'GLOBAL PAYMENT\nTECHNOLOGY',
  united: 'GLOBALLY CONNECTED\nU.S. AIRLINE',
};

const PartnerStoriesTabs = ({ activeBrandTab, setActiveBrandTab }) => {
  const [activeCategoryTab, setActiveCategoryTab] = useState(0);
  const categories = ['TRANSPORTATION', 'CONSUMER PACKAGED GOODS', 'ACCOUNT PAGE', 'SIGN-IN PAGE'];
  const activeStudy = partnerStoriesData[activeBrandTab];

  return (
    <section className='cst-section'>
      <div className='cst-container'>
        {/* Content Area */}
        <div className='cst-content-area fade-in-image' key={activeCategoryTab}>
          {activeCategoryTab === 0 ? (
            <>
              {/* Left Side: Brand List */}
              <div className='cst-brand-list'>
                {partnerStoriesData.map((study, index) => {
                  const isActive = index === activeBrandTab;

                  const handleViewMore = () => {
                    const element = document.getElementById(`detail-${study.id}`);
                    if (element) {
                      element.scrollIntoView({ behavior: 'smooth' });
                    }
                  };

                  return (
                    <div key={study.id} className={`cst-brand-item ${isActive ? 'active' : ''}`}>
                      <h3 className='cst-brand-name-heading'>
                        <button
                          type='button'
                          className='cst-brand-name'
                          aria-pressed={isActive}
                          onClick={() => setActiveBrandTab(index)}
                        >
                          {study.name}
                        </button>
                      </h3>
                      {isActive && (
                        <div className='cst-brand-details'>
                          <p className='cst-brand-desc'>{study.description}</p>
                          <div className='cst-brand-actions'>
                            <ActionButton onClick={handleViewMore} text='View more' size='sm' />
                          </div>
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>

              {/* Right Side: Image and Overlay */}
              <div className='cst-image-area'>
                {banners[activeStudy.id] ? (
                  <OptimizedImage
                    key={activeStudy.id}
                    {...banners[activeStudy.id]}
                    className='cst-main-image fade-in-image'
                    alt={activeStudy.name}
                  />
                ) : (
                  <>
                    <OptimizedImage
                      key={activeStudy.id}
                      {...images[activeStudy.id]}
                      className='cst-main-image fade-in-image'
                      alt={activeStudy.name}
                    />
                    <div
                      key={`overlay-${activeStudy.id}`}
                      className='cst-image-overlay fade-in-image'
                      style={{ whiteSpace: 'pre-line' }}
                    >
                      <OptimizedImage
                        {...logos[activeStudy.id]}
                        alt={`${activeStudy.name} logo`}
                        className='cst-overlay-logo'
                      />
                      <div className='cst-overlay-text'>{brandLabels[activeStudy.id]}</div>
                    </div>
                  </>
                )}
              </div>
            </>
          ) : (
            <div
              className='cst-filler-content'
              style={{
                padding: '4rem 2rem',
                textAlign: 'center',
                width: '100%',
                minHeight: '400px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexDirection: 'column',
              }}
            >
              <h3
                style={{
                  fontSize: '28px',
                  marginBottom: '16px',
                  color: '#101820',
                  fontWeight: 'bold',
                }}
              >
                {categories[activeCategoryTab]}
              </h3>
              <p
                style={{
                  fontSize: '18px',
                  color: '#101820',
                  maxWidth: '600px',
                  margin: '0 auto',
                  lineHeight: '1.6',
                }}
              >
                This section is currently under construction. More partner stories and insights
                regarding {categories[activeCategoryTab].toLowerCase()} will be available soon.
                Please check back later.
              </p>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default PartnerStoriesTabs;
